import { Option } from "./Option";
import { Size } from "./Size";
import { PaletteColor } from "./PaletteColor";
import { BackgroundImage } from "./BackgroundImage";

export default class Product {
  productId;
  productName;
  sizes;
  options;
    palettecolors;
    backgroundimages;

  constructor(jsonData) {
    Object.assign(this, jsonData);
    this.sizes = [];
    for (let s of jsonData.sizes) {
      this.sizes.push(new Size(s));
    }
    this.options = [];
    for (let ot of jsonData.options) {
      this.options.push(new Option(ot));
      }
      console.log(jsonData);
      this.backgroundimages = [];
      for (let bi of jsonData.backgroundimages) {
          this.backgroundimages.push(new BackgroundImage(bi));
      }
    this.palettecolors = [];
    for (let pc of jsonData.palette.floss) {
      this.palettecolors.push(new PaletteColor(pc));
      }

      
  }
}
